import { String } from '../utils/utils/strings';
import { Injectable } from '@angular/core';
import { JwtHelper } from 'angular2-jwt';
import { ClResultado } from '../utils/dtos/clResultado';


@Injectable()
export class TokenService {

    tokenName = 'Token';
    tokenTemporal: any = '';

    constructor() {
    }


    public setToken(token: string) {
        window.sessionStorage.setItem(this.tokenName, token);
        window.localStorage.setItem(this.tokenName, token);
    }

    public getToken() {
      if (window.sessionStorage.getItem(this.tokenName)) {
        return window.sessionStorage.getItem(this.tokenName);
      } else {
            if (this.tokenTemporal.length > 0) {
                return this.tokenTemporal;
            } else {
                return 'MTpFQ0VCQUVEMjEyRDg1OTAz';
            }
      }
    }

    public clearToken() {
        window.sessionStorage.removeItem(this.tokenName);
    }

    public getUsername(): string {
        const token =  this.getToken();

        if (!String.IsNullOrWhiteSpace(token)) {
            const jwtHelper: JwtHelper = new JwtHelper();
            const claims = jwtHelper.decodeToken(token);

            if (claims) {
                for (const property in claims) {
                    if (property) {
                        const key: string = property;
                        if (key.indexOf('userName') !== -1) {
                            return claims[key];
                        }
                    }
                }
            }
        }

        return null;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/token.service.ts